"use client";

import dynamic from "next/dynamic";
import { useCropRequest } from "./cropStore";

// The cropper is fetched the first time a picture is picked — a page that never asks never downloads it.
const ImageCropHost = dynamic(() => import("./ImageCropHost"), {
  ssr: false
});

/** Mounted once beside the shell (ClientLayout): the crop dialog, while a slot has asked for one. */
export default function CropMount(t0) {
  const {
    lang
  } = t0;
  return useCropRequest() ? <ImageCropHost lang={lang} /> : null;
}